import { Box, Typography } from '@mui/material'

export const RestoreAccess = () => {
  return (
    <Box>
      <Typography variant="h2" align="center">
        Страница восстановления доступа
        <p>Тут текст</p>
      </Typography>
    </Box>
  )
}
